let filters = {
	company_id: {name: 'company_id', 'nickname': 'Company', type: 'text', options: {},selections: {}, size: 2}
}

module.exports = filters